import { Helmet } from "react-helmet-async";
import { CreateClientForm } from "@/components/reseller/create-client-form";
import { useNavigate } from "react-router-dom";
import PageTitle from "@/components/ui/page-title";

const CreateClientPage = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate('/reseller/dashboard');
  };

  const handleCancel = () => {
    navigate('/reseller/dashboard');
  };

  return (
    <>
      <Helmet>
        <title>Criar Cliente - Reseller MoovaTV</title>
        <meta name="description" content="Criar novo cliente no sistema de revendedor MoovaTV." />
      </Helmet>

      <div className="container mx-auto py-12">
        <PageTitle className="mb-8">Criar Cliente no</PageTitle>
        <CreateClientForm
          onSuccess={handleSuccess}
          onCancel={handleCancel}
        />
      </div>
    </>
  );
};

export default CreateClientPage;
